/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledMain }       from '../StyledMain';
import { Colours, Spacing } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';

/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledMainPicturePage = StyledMain.extend`
  padding: 90px ${Spacing.Small} ${Spacing.Small};
  background: linear-gradient(
    rgba(0, 0, 0, .65),
    rgba(0, 0, 0, .65)
  ), url(${props => props.background}) 0 0 / cover no-repeat;
  color: ${Colours.White};
  text-align: center;
  ${Media.Tablet`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 calc(50vw - 500px);
    height: calc(100vh - 60px);
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledMainPicturePage/index.js